const mon = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

export const managerList = [
	{ "name": "Alex Yarbrough", "value": "Alex Yarbrough"},
	{ "name": "Amanda Mincey", "value": "Amanda Mincey"},
	{ "name": "Carlee Padgett", "value": "Carlee Padgett"},
	{ "name": "Carole Cross", "value": "Carole Cross"},
	{ "name": "Christine Dugan", "value": "Christine Dugan"},	
	{ "name": "David Geipel", "value": "David Geipel"},
	{ "name": "Francis Pastorius", "value": "Francis Pastorius"},
	{ "name": "Jamie Hamilton", "value": "Jamie Hamilton"},
	{ "name": "Justice Welshans", "value": "Justice Welshans"},
	{ "name": "Kensli Reed", "value": "Kensli Reed"},
	{ "name": "Peter Crowell", "value": "Peter Crowell" },
	{ "name": "Sandi Griffith", "value": "Sandi Griffith" },
	{ "name": "Teresa Robinson", "value": "Teresa Robinson" },
	{ "name": "Heather Mikolajczak", "value": "Heather Mikolajczak" }
];
export const socialList = [
	{ "name": "Gretchen Lederer", "value": "Gretchen Lederer" },
	{ "name": "Justice Welshans", "value": "Justice Welshans" },
	
];
export const statusList = [
	{ "name": "Onboarding", "value": "onboarding"},
	{ "name": "Active", "value": "active"},
	{ "name": "Archived", "value": "archived"}
]
export const packageList = [
	{ "name": "Lite", "value": "lite"
	}, { "name": "Prime", "value": "prime"
	}, { "name": "Premium", "value": "premium"
	}, { "name": "Platinum", "value": "platinum" }
]
export const franchiseList = [
	{ "name": "No", "value": null},
	{ "name": "Big Bob's", "value": "bigBobs"},
	{ "name": "Floor To Ceiling", "value": "floorsToCeiling"}
]

export const promoVelocityFormList = [
	{"name": "No Coupon Form On Site", "value": "None"},
	{"name": "Custom Coupon", "value": "Custom Coupon"},
	{"name": "25off Coupon", "value": "25off Coupon"},
	{"name": "300 Coupon", "value": "300 Coupon"},
	{"name": "500 Coupon", "value": "500 Coupon"},
	{"name": "Carpet Coupon", "value": "Carpet Coupon"},
	{"name": "Community Coupon", "value": "Community Coupon"},
	{"name": "Daltile Coupon", "value": "Daltile Coupon"},
	{"name": "Fastlane Coupon", "value": "Fastlane Coupon"},
	{"name": "Firstresponders Coupon", "value": "Firstresponders Coupon"},
	{"name": "Flowers Coupon", "value": "Flowers Coupon"},
	{"name": "Generic500 Coupon", "value": "Generic500 Coupon"},
	{"name": "Generic1000 Coupon", "value": "Generic1000 Coupon"},
	{"name": "Hunterdouglas Coupon", "value": "Hunterdouglas Coupon"},
	{"name": "Karastan Coupon", "value": "Karastan Coupon"},
	{"name": "Laborday Coupon", "value": "Laborday Coupon"},
	{"name": "Military Coupon", "value": "Military Coupon"},
	{"name": "Mohawk Coupon", "value": "Mohawk Coupon"},
	{"name": "Piedmontmohawk Coupon", "value": "Piedmontmohawk Coupon"},
	{"name": "Puchercoretec Coupon", "value": "Puchercoretec Coupon"},
	{"name": "Rug Coupon", "value": "Rug Coupon"},
	{"name": "Senior Coupon", "value": "Senior Coupon"},
	{"name": "Shaw Coupon", "value": "Shaw Coupon"},
	{"name": "Teacher Coupon", "value": "Teacher Coupon"}
]
export const promoFloorToCeilingFormList = [
	{"name": "No Coupon Form On Site", "value": "None"},
	{"name": "Custom Coupon", "value": "Custom Coupon"},
	{"name": "Shaw Coupon", "value": "Shaw Coupon"},
	{"name": "F2C Coupon", "value": "F2C Coupon"},
]

export const semManagerList = [
	
	{ "name": "Jason Clark", "value": "Jason Clark"},
	{ "name": "Jonathan Lopez", "value": "Jonathan Lopez"},
	{ "name": "Mandy Kaur", "value": "Mandy Kaur"},
	{ "name": "Nicole Uba", "value": "Nicole Uba"}
];

export const seoManagerList = [
	{ "name": "Tiffany King", "value": "Tiffany King"},
	{ "name": "Ross Callahan", "value": "Ross Callahan" }
];

// converts Camel Case => camelCase
export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '');
}

// converts null values to empty string so input placeholders will work
export const valueEmpty = (value) => {
	if (value === null || value === "null") {
		value = "";
	}
	return value;
}

export const isChecked = (value) => {
	if (value && value !== 0 && value !== false && value !== "0" && value !== "false") {
		return "checked";
	}
}
export const isSelected = (option, value) => {
	if (String(option) === String(value)) {
		return "selected";
	}
}

// converts camelCase => Camel Case
export const toKeyName = (key) => {
		if (key === "retailerId") {
			key = "Retailer Id (internal use only)";
		}
		key = key.replace(/([A-Z])/g, ' $1');
		key = key.replace(/^./, function(str){
			return str.toUpperCase();
		});
		return key;
}

// converts price string to cents value: $5.43 => 543
export const numberToCents = (number) => {
	var price;
	if (number === "$0.00") {
		price = "0";
	} else {
		price = Math.round(100 * parseFloat(number.replace(/[$,]/g, '')));
	}
    return price;
}

// converts decimals to price: 5432.1 => $5,432.10
export const numberToPrice = (number) => {
	var price;
	if (number === 0 || number === null) {
		price = "$0.00";
	} else {
		//number = number/100;
		price = number.toLocaleString("en-US", {style:"currency", currency:"USD"});
	}
    return price;
}

// converts military time to standard time
export const toTime = (e) => {
	var t = "AM";
	if (e > 1200) {
		e = e - 1200;
		t = "PM";
	}
	e = e.toString();
	e = e.replace(/(?=.{2}$)/,':');
	e = e+t;
	return e;
}
// converts 2019-10-22 to October 22, 2019
export const formatDateDisplay = (date) => {
	var year = date.split('-')[0];
	var month = date.split('-')[1];
	var day = date.split('-')[2];
	
	month = mon[month-1];

	return month+" "+day+", "+year;
}
// converts time stamp to date
export const formatDate = (timestamp) => {
	timestamp = new Date(timestamp).toLocaleString();
	var date = timestamp.split(',')[0];
	var time = timestamp.split(',')[1];
	// console.log(date);
	
	var year = date.split('/')[2];
	var month = date.split('/')[0];
	var day = date.split('/')[1];

	date = year+"-"+month+"-"+day;

	return [date, time];
}

export const secondsToTime = (s) => {
	var d = Math.floor(s/86400);
	s %= 86400;
	var h = Math.floor(s/3600);
	s %= 3600;
	var m = Math.floor(s/60);
	s = s % 60;

	var time = d+" days & "+h+":"+m+":"+s;
	return time;
}

// converts "a string value" to "a-string-value" for URLs
export const toURL = (str) => {
	str = str.replace(/[^\w\s]/gi, '');
	str = str.replace(/[. ,:-]+/g, "-").toLowerCase();
	str = str.replace(/-$/, '');
	return str;
}

export const setBarHeight = () => {
	var bars = document.getElementsByClassName("bar");
	for (var i = bars.length - 1; i >= 0; i--) {
		var cap = bars[i].dataset.cap;
		var hgt = bars[i].dataset.height;
		bars[i].style.height = ((hgt/cap)*100)+"%";
	}
}
export const servePie = () => {
	var percent;
	var pie = document.getElementsByClassName("pie");
	for (var i = pie.length - 1; i >= 0; i--) {
		percent = pie[i].dataset.percent;
		pie[i].style.background = "conic-gradient(#02b6c4 "+percent+", #8fc73e 0)";
	}
}

export const highlighter = (text) => {
	text = text.replace( /\[.*?\]/g, "<span class='highlight'>$&</span>" );
	return text;
}




// WEBPACK FOOTER //
// ./src/helpers/uiFunctions/uiHelpers.js